// extracted by mini-css-extract-plugin
export default {"dialog":"LogoutRequiredDialog_dialog__hKeCw","icon":"LogoutRequiredDialog_icon__CMrUk","buttons":"LogoutRequiredDialog_buttons__-+tv0"};